export default "__VITE_ASSET__BQ3Ub10k__"